var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarkerD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LocationMarker_D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LocationMarker_D",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C7.12875,0 0,6.34195455 0,14.1673636 C0,21.9909091 3.75,27.9545455 15,41 C26.25,27.9545455 30,21.9909091 30,14.1673636 C30,6.34195455 22.873125,0 15,0 Z",
    id: "Shape",
    fill: "#124B4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "D",
    transform: "translate(10.515625, 8.578125)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4765625,5.6015625 C9.4765625,7.48177083 8.94140625,8.921875 7.87109375,9.921875 C6.80078125,10.921875 5.25520833,11.421875 3.234375,11.421875 L0,11.421875 L0,0 L3.5859375,0 C5.45052083,0 6.8984375,0.4921875 7.9296875,1.4765625 C8.9609375,2.4609375 9.4765625,3.8359375 9.4765625,5.6015625 Z M6.9609375,5.6640625 C6.9609375,3.2109375 5.87760417,1.984375 3.7109375,1.984375 L2.421875,1.984375 L2.421875,9.421875 L3.4609375,9.421875 C5.79427083,9.421875 6.9609375,8.16927083 6.9609375,5.6640625 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerD);
export default __webpack_public_path__ + "static/media/LocationMarker_D.f79399ed5edbb511a8f1744ae53527f8.svg";
export { ForwardRef as ReactComponent };